const NAMESPACE = "customList";

const KEYS = {
    noValueMessage: "noValueMessage"
};

const MESSAGES = {
    [KEYS.noValueMessage]: {
        value: "No value",
        comment: "Default valueless result for output field."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
